
import React from "react"

import PropTypes from "prop-types"

import { useStaticQuery, graphql } from "gatsby"

function Icon({ id, size, alt, className }) {

  const data = useStaticQuery(graphql` 
    query {
      allFile(filter: {
        sourceInstanceName: { eq: "icons" }
        extension: { eq: "svg" }
      }
      ) {
        edges {
          node {
            id
            base
            publicURL
          }
        }
      }
    }
  `)

  let imageFile = null
  data.allFile.edges.forEach(edge => {
    if (edge.node.base == "xa-" + id + ".svg") {
      imageFile = edge.node.publicURL
    }
  })

  if (imageFile == null) {
    throw new Error(`Missing icon id ${id}`);
  }

  return (
    <img src={imageFile} height={size} width={size} alt={alt ? alt : id} className={className} loading="lazy" />
  )

}

Icon.defaultProps = {
  size: 32,
  alt: "",
  className: "inline-block mr-2"
}

Icon.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  alt: PropTypes.string,
}

export default Icon
